export enum SignalRActionTypes {
  DefaultNone = -1,
  UserAccountingFirmSwitched = 0,
  NewWIPAdded = 1,
  UserUpdated = 2,
  UserRoleUpdated = 3,
  TeamRoleUpdated = 4,
  AccountingFirmUpdated = 5,
  ClientListExportReady = 6,
  ClientListExportFailed = 7
}

// Optional: Description mapping if needed
export const SignalRActionTypeDescriptions: Record<SignalRActionTypes, string> = {
  [SignalRActionTypes.DefaultNone]: 'Default',
  [SignalRActionTypes.UserAccountingFirmSwitched]: 'User Accounting Firm Switched',
  [SignalRActionTypes.NewWIPAdded]: 'New WIP Added',
  [SignalRActionTypes.UserUpdated]: 'User Updated',
  [SignalRActionTypes.UserRoleUpdated]: 'User Role Updated',
  [SignalRActionTypes.TeamRoleUpdated]: 'Team Role Updated',
  [SignalRActionTypes.AccountingFirmUpdated]: 'Accounting Firm Updated',
  [SignalRActionTypes.ClientListExportReady]: 'Client List Export Ready',
  [SignalRActionTypes.ClientListExportFailed]: 'Client List Export Failed'
};
